import { createRouter, createWebHistory } from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Layout from "@/layout/index.vue";
import personLayout from "@/layout/person/index.vue";

import { getToken } from "@/utils/common";
import { changeProjectByCode } from "@/api/common";

const routes = [
	{
		path: "/login",
		component: () => import("@/views/LoginPage.vue"),
		meta: {
			title: "登录",
		},
	},
	{
		path: "/person",
		redirect: "/person/project",
		component: personLayout,
		meta: {
			title: "个人版",
		},
		children: [
			{
				path: "project",
				component: () => import("@/views/person/project.vue"),
				meta: {
					title: "项目列表",
				},
			},
			{
				path: "project-manage",
				component: () => import("@/views/person/projectManage.vue"),
				meta: {
					title: "项目管理",
				},
			},
			{
				path: "sub-project-manage",
				component: () => import("@/views/person/subProjectManage.vue"),
				meta: {
					title: "子项目管理",
				},
			},
			{
				path: "equity",
				component: () => import("@/views/person/center/equity.vue"),
				meta: {
					title: "我的权益",
				},
			},
			{
				path: "order",
				component: () => import("@/views/person/center/order.vue"),
				meta: {
					title: " 我的订单",
				},
			},
			// Person
			{
				path: "/manage/database",
				name: "Manage-Database",
				component: () => import("@/views/person/manage/database/index.vue"),
			},
			{
				path: "/manage/database/sub",
				name: "Manage-Database-Sub",
				component: () => import("@/views/person/subProject/database.vue"),
			},
			{
				path: "/manage/database/followup",
				name: "Manage-Database-Followup",
				component: () => import("@/views/person/manage/database/followup.vue"),
			},
			{
				path: "/manage/database/followup/sub",
				name: "Manage-Database-Followup-Sub",
				component: () => import("@/views/person/subProject/followup.vue"),
			},
			{
				path: "/manage/database/config",
				name: "Manage-Database-Config",
				component: () =>
					import("@/views/person/manage/database/database-config.vue"),
			},
			{
				path: "/manage/database/config/sub",
				name: "Manage-Database-Config-Sub",
				component: () =>
					import("@/views/person/subProject/database-config.vue"),
			},
			{
				path: "/manage/followup",
				name: "Manage-Followup",
				component: () => import("@/views/person/manage/followup/index.vue"),
			},
			{
				path: "/manage/fix-followup-plan",
				name: "Manage-Followup-FixPlan",
				component: () => import("@/views/person/manage/followup/fixPlan.vue"),
			},
			{
				path: "/manage/followup/config",
				name: "Manage-Followup-Config",
				component: () => import("@/views/person/manage/followup/config.vue"),
			},
			{
				path: "/manage/permissions",
				name: "Manage-Permissions",
				component: () => import("@/views/person/manage/permissions.vue"),
			},
			{
				path: "/audit-log",
				name: "Audit-Log",
				component: () => import("@/views/person/manage/audit-log.vue"),
				meta: { title: "审计日志" },
			},
			{
				path: "/manage/pii-rule",
				name: "Manage-Pii-Rule",
				component: () => import("@/views/person/manage/pii-rule.vue"),
				meta: { title: "PII规则配置" },
			},
			{
				path: "/manage/metadata-versioning",
				name: "Manage-Metadata-Versioning",
				component: () => import("@/views/person/manage/metadata-versioning.vue"),
				meta: { title: "元数据历史" },
			},
			{
				path: "/manage/lifecycle",
				name: "Manage-Lifecycle",
				component: () => import("@/views/person/manage/lifecycle.vue"),
				meta: { title: "生命周期与留存" },
			},
			{
				path: "/manage/scope-tree",
				name: "Manage-Scope-Tree",
				component: () => import("@/views/person/manage/scope-tree.vue"),
				meta: { title: "组织架构" },
			},
			{
				path: "/manage/sub-center",
				name: "Manage-Sub-Center",
				component: () => import("@/views/person/manage/sub-center.vue"),
			},
			{
				path: "/manage/random",
				name: "Manage-Random",
				component: () => import("@/views/person/manage/random.vue"),
			},
			{
				path: "/manage/random/view",
				name: "Manage-Random-View",
				component: () => import("@/views/person/manage/random-view.vue"),
			},
			{
				path: "/manage/schema",
				component: () => import("@/views/person/manage/schema.vue"),
				meta: {
					title: "架构初始生成",
				},
			},
			{
				path: "/manage/schema-snapshot",
				component: () => import("@/views/person/manage/schema-snapshot.vue"),
				meta: {
					title: "架构快照与重置",
				},
			},
			{
				path: "/manage/agent",
				name: "Manage-Agent",
				component: () => import("@/views/person/manage/agent/index.vue"),
				meta: {
					title: "Agent配置",
				},
			},
			{
				path: "/manage/consent",
				name: "Manage-Consent",
				component: () => import("@/views/person/manage/consent/index.vue"),
				meta: { title: "知情同意书" },
			},
			// COCHE §10.1.14 — encryption-at-rest posture dashboard
			{
				path: "/coche/encryption-status",
				name: "Coche-Encryption-Status",
				component: () => import("@/views/coche/EncryptionStatus.vue"),
				meta: { title: "加密状态" },
			},
		],
	},
	{
		path: "/",
		redirect: "/person/project",
		component: Layout,
		children: [
			{
				path: "/home",
				component: () => import("@/views/HomePage.vue"),
				meta: {
					title: "首页",
				},
			},
			/* 数据同步（每日 HIS ETL 更新看板） */
			{
				path: "/data-sync/daily",
				component: () => import("@/views/data-sync/daily-updates.vue"),
				meta: {
					title: "数据同步",
				},
			},
			/* 数据管理 */
			{
				path: "/patient/list",
				component: () => import("@/views/data-manage/patient/list.vue"),
				meta: {
					title: "患者列表",
				},
			},
			{
				path: "/patient/add",
				component: () => import("@/views/data-manage/patient/add.vue"),
				meta: {
					title: "新增患者",
				},
			},
			{
				path: "/patient/edit",
				component: () => import("@/views/data-manage/patient/edit.vue"),
				meta: {
					title: "编辑患者",
				},
			},
			{
				path: "/patient/file",
				component: () => import("@/views/data-manage/patient/PatientFile.vue"),
				meta: {
					title: "患者文件视图",
				},
			},
			{
				path: "/patient/source",
				component: () => import("@/views/data-manage/patient/source.vue"),
				meta: {
					title: "溯源",
				},
			},
			{
				path: "/retrieval",
				component: () => import("@/views/data-manage/retrieval/index.vue"),
				meta: {
					title: "数据检索",
				},
			},
			{
				path: "/retrieval/export",
				component: () => import("@/views/data-manage/retrieval/export.vue"),
				meta: {
					title: "数据检索-导出",
				},
			},
			// COCHE governance workflow — reached from the in-project sidebar, so
			// they must render under the project Layout. They used to be children
			// of /person (personLayout), so clicking "My Requests" / "Approval
			// Inbox" from inside a project swapped the whole sidebar shell.
			{
				path: "/manage/governance-inbox",
				name: "Manage-Governance-Inbox",
				component: () => import("@/views/person/manage/governance-inbox.vue"),
				meta: { title: "审批收件箱" },
			},
			{
				path: "/manage/my-requests",
				name: "Manage-My-Requests",
				component: () => import("@/views/person/manage/my-requests.vue"),
				meta: { title: "我的申请" },
			},
			// Same reasoning: both hang off 数据管理 (sys_menu 6) in the in-project
			// sidebar, so they must render under the project Layout too. As children of
			// /person they mounted personLayout, which renders the index-group menu — a
			// user whose roles are scoped to one project has none of those, so the
			// sidebar went blank on arrival.
			{
				path: "/manage/ingestion-hardening",
				name: "Manage-Ingestion-Hardening",
				component: () => import("@/views/person/manage/ingestion-hardening.vue"),
				meta: { title: "数据接入加固" },
			},
			{
				path: "/manage/ehealth",
				name: "Manage-Ehealth",
				component: () => import("@/views/person/manage/ehealth.vue"),
				meta: { title: "eHealth 上传" },
			},
			{
				path: "/manage/ehr-viewer",
				name: "Manage-Ehr-Viewer",
				component: () => import("@/views/person/manage/ehr-viewer.vue"),
				meta: { title: "eHR Viewer" },
			},
			{
				path: "/analysis",
				component: () => import("@/views/data-manage/analysis/index.vue"),
				meta: {
					title: "数据分析",
				},
			},
			/* AI 识别 */
			{
				path: "/discern/list",
				component: () => import("@/views/discern/list.vue"),
				meta: {
					title: "AI识别列表",
				},
			},
			{
				path: "/discern/view",
				component: () => import("@/views/discern/view.vue"),
				meta: {
					title: "AI识别详情",
				},
			},
			/* 随访管理 */
			{
				path: "/followup/list",
				component: () => import("@/views/followup/list.vue"),
				meta: {
					title: "随访列表",
				},
			},
			{
				path: "/followup/edit",
				component: () => import("@/views/followup/edit.vue"),
				meta: {
					title: "随访详情",
				},
			},
			/* 多中心管理 */
			{
				path: "/multicenter/overview",
				component: () => import("@/views/multicenter/overview.vue"),
				meta: {
					title: "多中心概览",
				},
			},
			{
				path: "/multicenter/patient",
				component: () => import("@/views/multicenter/patient.vue"),
				meta: {
					title: "多中心患者列表",
				},
			},
			{
				path: "/multicenter/followup",
				component: () => import("@/views/multicenter/followup.vue"),
				meta: {
					title: "多中心随访管理",
				},
			},
			{
				path: "/analytics/overview",
				component: () => import("@/views/analytics/overview.vue"),
				meta: {
					title: "分析概览",
				},
			},


			{
				path: "/analytics/dataset",
				component: () => import("@/views/analytics/dataset.vue"),
				meta: {
					title: "数据集",
				},
			},

			{
				path: "/analytics/encoding",
				component: () => import("@/views/analytics/encoding.vue"),
				meta: {
					title: "字段编码",
				},
			},

			{
				path: "/analytics/selection",
				component: () => import("@/views/analytics/selection.vue"),
				meta: {
					title: "字段筛选",
				},
			},

			{
				path: "/analytics/algorithm",
				component: () => import("@/views/analytics/algorithm.vue"),
				meta: {
					title: "算法执行",
				},
			},

			{
				path: "/analytics/report",
				component: () => import("@/views/analytics/report.vue"),
				meta: {
					title: "统计报告",
				},
			},

			/* COCHE Tier-B extended modules — project-scoped, so they live under the project Layout and
			   keep the project sidebar (sys_menu lists them under 扩展模块 / Extended Modules) */
			// COCHE Tier-B — imaging workspace (studies / upload / jobs / annotation tasks)
			{
				path: "/coche/imaging",
				name: "Coche-Imaging-Workspace",
				component: () => import("@/views/coche/ImagingWorkspace.vue"),
				meta: { title: "影像工作台 (Imaging workspace)" },
			},
			// COCHE Tier-B B4 — two-reader adjudication
			{
				path: "/coche/adjudication/:taskId",
				name: "Coche-Adjudication",
				component: () => import("@/views/coche/AdjudicationView.vue"),
				meta: { title: "影像标注仲裁 (Adjudication)" },
			},
			// COCHE §10.1.11 — DICOM viewer demo (cvd_hk)
			{
				path: "/coche/imaging/:patientNo",
				name: "Coche-Imaging-Viewer",
				component: () => import("@/views/coche/ImagingViewer.vue"),
				meta: { title: "影像 (DICOM)" },
			},
			// COCHE §10.1.12 — InfluxDB time-series viewer demo (cvd_hk)
			{
				path: "/coche/timeseries/:patientNo",
				name: "Coche-TimeSeries-Viewer",
				component: () => import("@/views/coche/TimeSeriesViewer.vue"),
				meta: { title: "生理信号 (Time-series)" },
			},
			// COCHE Deliverable 2 — federated learning runs + ML model registry
			{
				path: "/coche/ml-registry",
				name: "Coche-ML-Registry",
				component: () => import("@/views/coche/MlRegistry.vue"),
				meta: { title: "联邦学习 / 模型注册 (ML registry)" },
			},
			// COCHE — FHIR R4 / OMOP CDM v5.4 interop mapping editor + exports (cvd_hk)
			{
				path: "/coche/interop",
				name: "Coche-Interop",
				component: () => import("@/views/coche/InteropMapping.vue"),
				meta: { title: "FHIR / OMOP 互操作" },
			},
			/* 科研分析平台 */
			{
				path: "/research/overview",
				component: () => import("@/views/analytics/platform/overview.vue"),
				meta: {
					title: "分析概览",
				},
			},
			{
				path: "/research/library",
				component: () => import("@/views/analytics/platform/library.vue"),
				meta: {
					title: "研究资料",
				},
			},
			{
				path: "/research/topics",
				component: () => import("@/views/analytics/platform/topics.vue"),
				meta: {
					title: "课题推荐",
				},
			},
			{
				path: "/research/workbench",
				component: () => import("@/views/analytics/platform/workbench.vue"),
				meta: {
					title: "分析工作台",
				},
			},
			{
				path: "/research/inbox",
				component: () => import("@/views/analytics/platform/inbox.vue"),
				meta: {
					title: "治疗回顾",
				},
			},

			/* 门诊运营 */
			{
				path: "/clinic/qabot-overview",
				component: () => import("@/views/clinic/qabot-overview.vue"),
				meta: {
					title: "运营概览",
				},
			},
			{
				path: "/clinic/appointments",
				component: () => import("@/views/clinic/appointments.vue"),
				meta: {
					title: "加号申请",
				},
			},
			{
				path: "/clinic/checkins",
				component: () => import("@/views/clinic/checkins.vue"),
				meta: {
					title: "报到列表",
				},
			},
			{
				path: "/clinic/chat-history",
				component: () => import("@/views/clinic/chat-history.vue"),
				meta: {
					title: "聊天历史",
				},
			},
			{
				path: "/clinic/qabot-users",
				component: () => import("@/views/clinic/qabot-users.vue"),
				meta: {
					title: "门诊用户管理",
				},
			},
			{
				path: "/clinic/qabot-users/:id",
				component: () => import("@/views/clinic/qabot-user-detail.vue"),
				meta: {
					title: "用户详情",
				},
			},
			{
				path: "/clinic/assessment-results",
				component: () => import("@/views/clinic/assessment-results.vue"),
				meta: {
					title: "评估结果",
				},
			},
		],
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/404Page.vue"),
		meta: {
			title: "错误",
		},
	},
	{
		path: "/:pathMatch(.*)*",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes: routes,
});

// Recover from lazy-import failures (Vite dev re-optimize, prod chunk-hash drift,
// transient HMR-served empty modules). Without this, Vue Router silently aborts
// the navigation and the user sees the click "do nothing" or a blank page.
router.onError((error, to) => {
	const msg = String((error as { message?: string })?.message ?? error ?? "");
	const isChunkError =
		/Failed to fetch dynamically imported module/i.test(msg) ||
		/Loading chunk [^ ]+ failed/i.test(msg) ||
		/Importing a module script failed/i.test(msg) ||
		/Failed to resolve module specifier/i.test(msg) ||
		/error loading dynamically imported module/i.test(msg);
	if (!isChunkError) {
		console.error("Router error (not auto-recovered):", msg, error);
		return;
	}
	console.warn("Lazy route load failed, reloading to recover:", msg);
	const target = to?.fullPath || window.location.pathname + window.location.search;
	window.location.replace(target);
});

// Catch unhandled rejections from dynamic imports that bypassed the router's
// error channel (some Vite dev failures surface here instead of router.onError).
window.addEventListener("unhandledrejection", (event) => {
	const msg = String((event.reason as { message?: string })?.message ?? event.reason ?? "");
	if (
		/Failed to fetch dynamically imported module/i.test(msg) ||
		/Loading chunk [^ ]+ failed/i.test(msg) ||
		/error loading dynamically imported module/i.test(msg)
	) {
		console.warn("Dynamic import rejected, reloading to recover:", msg);
		window.location.reload();
	}
});

// Deferred "stale bundle" reload: setting window.location.href DURING the
// navigation that triggered the version check aborts that route's onMounted
// fetches (e.g. project.vue's /web-project/list POST → empty project list
// until F5). We flag the mismatch here and swap to the fresh bundle on the
// NEXT navigation instead, by which point the current view's mount-time
// requests have already completed.
let pendingVersionReload = false;

router.beforeEach((to, _from, next) => {
	if (pendingVersionReload) {
		pendingVersionReload = false;
		window.location.href = to.fullPath;
		return;
	}

	const oldV = localStorage.getItem("version");
	fetch("/version.json?t=" + new Date().getTime())
		.then((res) => res.json())
		.then((data) => {
			if (!data || !data.version) return;
			if (oldV === null) {
				localStorage.setItem("version", data.version);
				return;
			}
			if (oldV !== data.version) {
				localStorage.setItem("version", data.version);
				pendingVersionReload = true;
			}
		})
		.catch(() => {});

	NProgress.configure({ showSpinner: false });
	NProgress.start();

	// Dark mode is an authenticated-user preference — strip on /login so
	// the login form keeps its designed light palette, and re-apply when
	// navigating back into authenticated routes (e.g. after login).
	const root = document.documentElement;
	if (to.path === "/login") {
		root.classList.remove("dark");
	} else if (localStorage.getItem("darkMode") === "true") {
		root.classList.add("dark");
	}

	const token = getToken();
	if (to.path === "/login") {
		// 进入登入页面
		next();
	} else if (!token) {
		// 未登录
		next({
			path: "/login",
		});
	} else {
		const projectCode = to.query.projectCode as string;
		const currentCode = localStorage.getItem("projectCode");
		if (projectCode && projectCode !== currentCode) {
			changeProjectByCode(projectCode).then(() => {
				localStorage.setItem("projectCode", projectCode);
				next();
			}).catch(() => {
				next();
			});
			return;
		}
		next();
	}
});

router.afterEach(() => {
	NProgress.done();
});

export default router;
